/* PM - popover inteligente para descripcion corta de product cards.
   Deteccion de truncado REAL (nunca por longitud de caracteres).

   PM 27-10-2026 (INP / PageSpeed): version optimizada, mismo
   comportamiento visible.
   - Antes: al cargar se median TODAS las cards, cada una con 2 reflows
     forzados (quitar el line-clamp, medir, reponerlo), y un
     MutationObserver sobre todo el body re-escaneaba el documento en
     cada cambio del DOM. Lighthouse lo marcaba como el principal
     causante de reflows forzados en la home (~150 ms en celular).
   - Ahora: el truncado se detecta con scrollHeight > clientHeight, que
     con -webkit-line-clamp + overflow:hidden ya entrega el alto natural
     del texto (verificado: mismo resultado que el metodo anterior en
     el 100% de las cards de la home y de colecciones, 27-10-2026). Solo
     lecturas, sin tocar estilos.
   - Solo se miden las cards que se acercan a la pantalla
     (IntersectionObserver), por lotes: primero se leen todas las
     alturas y luego se escriben los atributos (sin layout thrashing).
   - El escaneo de cards nuevas (Ajax/quick add/Theme Editor) se agrupa
     y corre cuando el navegador esta libre.
   - Al cambiar el ancho de la ventana se re-miden solo las visibles.

   Un unico popover global (portal en document.body) reutilizado por
   todas las cards. Desktop (hover-capable): mouseover/focusin abren,
   mouseout/focusout cierran, Escape cierra. Mobile/touch: tap
   abre/cierra, tap fuera cierra. */
(function () {
  if (window.pmCardDescriptionHoverInit) return;
  window.pmCardDescriptionHoverInit = true;

  var SELECTOR = '.pm-card-short-description';
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  var popover = null;
  var activeTrigger = null;
  var visible = new Set();
  var pending = new Set();
  var frameRequested = false;

  function ensurePopover() {
    if (popover) return popover;
    popover = document.createElement('div');
    popover.className = 'pm-description-popover';
    popover.id = 'PmDescriptionPopover';
    popover.setAttribute('role', 'tooltip');
    popover.hidden = true;
    document.body.appendChild(popover);
    return popover;
  }

  function applyState(el, truncated) {
    var value = truncated ? 'true' : 'false';
    if (el.getAttribute('data-pm-description-truncated') === value) return;
    el.setAttribute('data-pm-description-truncated', value);

    if (truncated) {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      if (!el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', 'false');
      el.setAttribute('aria-describedby', 'PmDescriptionPopover');
    } else {
      el.removeAttribute('tabindex');
      el.removeAttribute('role');
      el.removeAttribute('aria-expanded');
      el.removeAttribute('aria-describedby');
      if (activeTrigger === el) close();
    }
  }

  /* Mide un lote: primero TODAS las lecturas, despues TODAS las escrituras. */
  function measureBatch(elements) {
    var results = [];
    elements.forEach(function (el) {
      if (!el.isConnected) return;
      var clamped = el.clientHeight;
      if (!clamped) return; /* oculta (pestana inactiva, etc.): se mide cuando se vea */
      results.push([el, el.scrollHeight - clamped > 1]);
    });
    results.forEach(function (pair) {
      applyState(pair[0], pair[1]);
    });
  }

  function flush() {
    frameRequested = false;
    if (!pending.size) return;
    var batch = Array.from(pending);
    pending.clear();
    measureBatch(batch);
  }

  function queue(el) {
    pending.add(el);
    if (!frameRequested) {
      frameRequested = true;
      requestAnimationFrame(flush);
    }
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
            queue(entry.target);
          } else {
            visible.delete(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' })
    : null;

  function scanNew() {
    var nodes = document.querySelectorAll(SELECTOR + ':not([data-pm-description-scanned])');
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      el.setAttribute('data-pm-description-scanned', '1');
      if (io) {
        io.observe(el);
      } else {
        queue(el);
      }
    });
  }

  /* Escaneo de cards nuevas agrupado y en tiempo libre. */
  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    var run = function () {
      scanScheduled = false;
      scanNew();
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 500 });
    } else {
      setTimeout(run, 150);
    }
  }

  /* Re-medir las visibles solo si cambia el ancho (no en el scroll de iOS). */
  var lastWidth = window.innerWidth;
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      visible.forEach(queue);
    }, 200);
  });

  function isTruncatedTrigger(el) {
    return !!el && el.getAttribute('data-pm-description-truncated') === 'true';
  }

  function positionPopover(trigger, pop) {
    var gap = 8;
    var rect = trigger.getBoundingClientRect();
    var popRect = pop.getBoundingClientRect();
    var viewportW = document.documentElement.clientWidth;
    var viewportH = document.documentElement.clientHeight;

    var top = rect.bottom + gap;
    if (top + popRect.height > viewportH && rect.top - gap - popRect.height >= 0) {
      top = rect.top - gap - popRect.height;
      pop.classList.add('pm-description-popover--above');
    } else {
      pop.classList.remove('pm-description-popover--above');
    }

    var left = rect.left;
    if (left + popRect.width > viewportW - gap) {
      left = viewportW - gap - popRect.width;
    }
    if (left < gap) left = gap;

    pop.style.top = top + 'px';
    pop.style.left = left + 'px';
  }

  function open(trigger) {
    if (activeTrigger === trigger) return;
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');

    var pop = ensurePopover();
    pop.textContent = trigger.textContent.trim();
    activeTrigger = trigger;
    pop.hidden = false;
    positionPopover(trigger, pop);
    trigger.setAttribute('aria-expanded', 'true');
  }

  function close() {
    if (!activeTrigger) return;
    activeTrigger.setAttribute('aria-expanded', 'false');
    activeTrigger = null;
    if (popover) popover.hidden = true;
  }

  if (!isTouch) {
    document.addEventListener('mouseover', function (event) {
      var el = event.target.closest(SELECTOR);
      if (isTruncatedTrigger(el)) open(el);
    });

    document.addEventListener('mouseout', function (event) {
      var el = event.target.closest(SELECTOR);
      if (el && el === activeTrigger) close();
    });
  }

  document.addEventListener('focusin', function (event) {
    var el = event.target.closest(SELECTOR);
    if (isTruncatedTrigger(el)) open(el);
  });

  document.addEventListener('focusout', function (event) {
    if (activeTrigger && event.target === activeTrigger) close();
  });

  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Escape' || event.key === 'Esc') && activeTrigger) close();
  });

  if (isTouch) {
    document.addEventListener('click', function (event) {
      var el = event.target.closest(SELECTOR);

      if (isTruncatedTrigger(el)) {
        event.preventDefault();
        event.stopPropagation();
        if (activeTrigger === el) {
          close();
        } else {
          open(el);
        }
        return;
      }

      if (activeTrigger && !(popover && popover.contains(event.target))) {
        close();
      }
    });
  }

  scanNew();

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            scheduleScan();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
